import axios from "axios";

export const updateProfile = async (payload) => {
    let result = await axios.post('https://spice-api.pearlfall.vercel.app'+`/users/update`, payload);
    console.log("request result", result);
    return result.data;
};
